























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

import { STORE_KEY, store } from "./_store";

import TitleBar from "@/components/Elements/TitleBar.vue";
import AgentDetails from "../AgentDetails/AgentDetails.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "documents",
      "lastMeta"
    ])
  },
  components: {
    TitleBar
  }
})
export default class AgentList extends Vue {
  get titleStack() {
    return ["Агенты"];
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }

  private delayFilter: any = null;

  onSearch(filter: any) {
    if (this.delayFilter) {
      clearTimeout(this.delayFilter);
    }
    this.delayFilter = setTimeout(() => {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...filter
        }
      });
      this.delayFilter = null;
    }, 500);
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.$router.replace({
      query: { ...this.$route.query, page }
    });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.push({
      name: "agent-details",
      params: {
        id: row.id
      }
    });
  }

  addAgent() {
    this.$buefy.modal.open({
      component: AgentDetails,
      props: {
        params: { id: "new", from: "list" }
      },
      events: {
        "agent-saved": () => {
          this.loadData();
        }
      },
      onCancel: () => {
        this.loadData();
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form",
      parent: this
    });
  }

  public toArchive(agentId: any) {
    this.$buefy.dialog.confirm({
      message: "Отправить агента в архив?",
      confirmText: "В архив",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: () => {
        this.$store
          .dispatch(`${STORE_KEY}/toArchive`, agentId)
          .then(() => {
            this.loadData();
          });
      }
    });
  }

  public toUnarchive(agentId: any) {
    this.$buefy.dialog.confirm({
      message: "Восстановить агента из архива?",
      confirmText: "Восстановить",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: () => {
        this.$store
          .dispatch(`${STORE_KEY}/toUnarchive`, agentId)
          .then(() => {
            this.loadData();
          });
      }
    });
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  public loadData() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  @Watch("$route.query")
  public handleParamsChange() {
    this.loadData();
  }
}
